{
    "version": "2026-09-04-draft-1",
    "status": "DRAFT_UNAPPROVED",
    "approvedBy": null,
    "approvedAt": null,
    "rules": [
        {
            "id": "unresponsive",
            "label": "깨워도 반응이 없거나 의식이 뚜렷하지 않음",
            "action": "RED_119",
            "sourceUrl": "https://www.nfa.go.kr/"
        },
        {
            "id": "not_breathing_or_gasping",
            "label": "숨을 쉬지 않거나 헐떡이는 상태",
            "action": "RED_119",
            "sourceUrl": "https://www.nfa.go.kr/"
        },
        {
            "id": "severe_breathing_difficulty",
            "label": "말하기 어렵거나 입술이 파래질 정도로 숨쉬기 힘듦",
            "action": "RED_119",
            "sourceUrl": "https://www.nfa.go.kr/"
        },
        {
            "id": "ongoing_seizure",
            "label": "경련이 계속되거나 반복되며 의식이 돌아오지 않음",
            "action": "RED_119",
            "sourceUrl": "https://www.nfa.go.kr/"
        },
        {
            "id": "uncontrolled_bleeding",
            "label": "눌러도 멈추지 않는 심한 출혈",
            "action": "RED_119",
            "sourceUrl": "https://www.nfa.go.kr/"
        }
    ]
}
